import { render, staticRenderFns } from "./ScoreSettingList.vue?vue&type=template&id=4525ab65"
import script from "../../../controllers/custom/score_setting/score-setting-list.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/score_setting/score-setting-list.js?vue&type=script&lang=js&external"
import style0 from "./ScoreSettingList.vue?vue&type=style&index=0&id=4525ab65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports